module.exports = __webpack_public_path__ + "assets/img/trade.51dac7ec.svg";